import styled from 'styled-components'

export const FaqItemContentUi = styled.div<{
  expanded: boolean
}>`
  height: ${p => (p.expanded ? 'auto' : 0)};
  overflow: ${p => (p.expanded ? 'visible' : 'hidden')};
`
